var path = '/modification/modification.tpl.html';
var html = "<div ng-class=\"{'modificationsStripeInProgress': viewModel.changeSetExists}\">\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;